import script from "./PrioritiesView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrioritiesView.vue?vue&type=script&setup=true&lang=js"

import "./PrioritiesView.vue?vue&type=style&index=0&id=c6a6757a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6a6757a"]])

export default __exports__